export const AVATAR_PALETTE = [
  '#E63946',
  '#457B9D',
  '#2A9D8F',
  '#E9C46A',
  '#264653',
  '#8338EC',
  '#FF006E',
  '#3A86FF',
  '#FB5607',
  '#06D6A0',
  '#9B5DE5',
  '#00BBF9',
  '#FEE440',
  '#F15BB5',
  '#00F5D4',
  '#5C0029',
] as const;

export function normalizeAvatarPaletteColor(
  hex: string | null | undefined,
  fallback: (typeof AVATAR_PALETTE)[number],
): string {
  const u = (hex ?? '').trim().toUpperCase();
  return (AVATAR_PALETTE as readonly string[]).includes(u) ? u : fallback;
}

export function avatarConfigDisplayColors(
  config: { color1?: string | null; color2?: string | null } | null | undefined,
  fallbacks: readonly [string, string] = [AVATAR_PALETTE[0], AVATAR_PALETTE[1]],
): { color1: string; color2: string } {
  const c1 = (config?.color1 ?? '').trim();
  const c2 = (config?.color2 ?? '').trim();
  return {
    color1: c1 || fallbacks[0],
    color2: c2 || fallbacks[1],
  };
}
